export { default } from './TechSpecifications';
